import { jsx as o, jsxs as L } from "react/jsx-runtime";
import { withManagedProps as _ } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as w } from "@made-people/react-prop-guard";
import { useSearchResultLoadMore as h } from "@made-people/grease-search";
import { buttonContentPropsSchema as E, ButtonAsLink as I } from "@made-people/blueprint-button";
import { loadMoreBlueprint as N } from "./index-blueprint.es.js";
import { useTranslate as j } from "@made-people/grease-translations";
import { badgeSchema as S, Badge as y } from "@made-people/blueprint-badge";
import { motion as d, AnimatePresence as k } from "motion/react";
import B from "clsx";
import { useRef as A, useEffect as C } from "react";
import "@made-people/blueprint";
const O = ({
  slots: a
}) => {
  const s = j(), { paginationStats: t } = h();
  return /* @__PURE__ */ o("span", { className: a.seenProducts, children: s("Search_Seen_Products", {
    seen: t.seen,
    total: t.totalItems
  }) });
}, R = ({
  slots: a
}) => {
  const {
    paginationStats: { seen: s, totalItems: t }
  } = h(), c = t > 0 ? s / t * 100 : 0;
  return /* @__PURE__ */ o("div", { className: a.progressbar, children: /* @__PURE__ */ o(
    d.div,
    {
      className: a.progressbarFill,
      animate: { width: `${c}%` },
      transition: { duration: 0.5, ease: "easeInOut" }
    }
  ) });
}, $ = e.object({
  buttonVariants: E.shape.variants.optional(),
  variants: e.custom().optional(),
  indicators: e.array(e.enum(["progressbar", "seenProducts"])).optional(),
  enabled: e.boolean().optional(),
  badge: S.optional(),
  className: e.string().optional(),
  infiniteScroll: e.object({
    enabled: e.boolean().optional(),
    threshold: e.number().optional()
  }).optional(),
  labels: e.object({
    enabled: e.boolean().optional(),
    as: e.literal("badge").optional(),
    start: e.string().optional(),
    end: e.string().optional()
  }).optional()
}), U = _(
  "LoadMore",
  w(
    {
      schema: $,
      defaultProps: {
        enabled: !0,
        indicators: ["progressbar", "seenProducts"],
        labels: {
          enabled: !0,
          as: "badge",
          start: "Load_More_Label_Start",
          end: "Load_More_Label_End"
        },
        infiniteScroll: {
          enabled: !0
        }
      }
    },
    ({
      buttonVariants: a,
      variants: s,
      indicators: t,
      enabled: c,
      badge: g,
      labels: r,
      className: v,
      infiniteScroll: n
    }) => {
      const { loadMore: m, canLoadMore: l, isLoading: b, pageIncrementHref: P } = h(), i = A(null);
      if (C(() => {
        if (!(n != null && n.enabled))
          return;
        const u = (n == null ? void 0 : n.threshold) ?? 400, f = new IntersectionObserver(
          (M) => {
            M.forEach((x) => {
              x.isIntersecting && l && !b && m();
            });
          },
          {
            root: null,
            // observe relative to the viewport
            // Extend the bottom boundary of the viewport by thresholdPx pixels
            rootMargin: `0px 0px ${u}px 0px`,
            threshold: 0
            // trigger as soon as any part of the element is visible
          }
        );
        return i.current && f.observe(i.current), () => {
          f.disconnect();
        };
      }, [i, m]), !c)
        return null;
      const p = N.styles(s);
      return /* @__PURE__ */ L("div", { ref: i, className: B(p.base, v), children: [
        (r == null ? void 0 : r.enabled) && /* @__PURE__ */ o(k, { mode: "wait", children: l ? /* @__PURE__ */ o(
          d.div,
          {
            initial: { y: -20, opacity: 0 },
            animate: {
              y: "0",
              opacity: 100,
              transition: {
                type: "spring",
                stiffness: 300,
                damping: 15,
                mass: 0.5
              }
            },
            exit: {
              y: -20,
              opacity: 0,
              transition: {
                duration: 0.15,
                ease: [0.68, -0.55, 0.27, 1.55],
                type: "tween"
              }
            },
            children: /* @__PURE__ */ o(y, { ...g, label: r == null ? void 0 : r.start })
          },
          "first"
        ) : /* @__PURE__ */ o(
          d.div,
          {
            initial: { y: 20, opacity: 0 },
            animate: {
              y: 0,
              opacity: 100,
              transition: {
                type: "spring",
                stiffness: 300,
                damping: 15,
                mass: 0.5
              }
            },
            exit: {
              y: 20,
              opacity: 0,
              transition: {
                duration: 0.15,
                ease: [0.68, -0.55, 0.27, 1.55],
                type: "tween"
              }
            },
            children: /* @__PURE__ */ o(y, { ...g, label: r == null ? void 0 : r.end })
          },
          "second"
        ) }),
        (t == null ? void 0 : t.includes("seenProducts")) && /* @__PURE__ */ o(
          O,
          {
            slots: {
              seenProducts: p.seenProducts
            }
          }
        ),
        (t == null ? void 0 : t.includes("progressbar")) && /* @__PURE__ */ o(R, { slots: p }),
        /* @__PURE__ */ o(
          d.div,
          {
            initial: { scale: 1, opacity: 1, pointerEvents: "auto" },
            animate: l ? { scale: 1, opacity: 1, pointerEvents: "auto" } : { scale: 0.5, opacity: 0, pointerEvents: "none" },
            transition: {
              duration: 0.15,
              ease: [0.68, -0.55, 0.27, 1.55],
              type: "tween"
            },
            className: p.buttonWrapper,
            children: /* @__PURE__ */ o(
              I,
              {
                link: {
                  href: P,
                  onClick: (u) => {
                    u.preventDefault(), m();
                  }
                },
                label: "Search_Load_More",
                variants: a,
                ...b ? { progress: "loading" } : {}
              }
            )
          }
        )
      ] });
    }
  )
);
export {
  U as LoadMore,
  R as Progressbar,
  O as SeenProducts,
  $ as loadMoreSchema
};
//# sourceMappingURL=index.es.js.map
